/**
 * Where a session starts (WARP-920, 2026-09-28): the RO Intake status dashboard. Mark and
 * Michelle both chose it as the first page after login.
 *
 * Bare /ro-intake is the Dashboard with All dealers picked (WARP-960): where the work is
 * across every dealer this user can reach. Mark, 2026-10-01: admins "have multiple
 * dealers. They're not going into one when they log in." A user with one dealer goes
 * straight to it, and anyone with no RO Intake dealer on to the Dealers list, so every
 * authenticated user can open this path.
 */
export const HOME_PATH = '/ro-intake'

/** The localStorage key for the last dealer a user worked on, one per user. */
export const lastDealerStorageKey = (userId) => `warp:last-dealer:${userId}`

/**
 * The last dealer this user worked on, or null. Storage can throw (private mode), and
 * losing this only costs a click on the dealer switcher.
 */
export const readLastDealerId = (userId) => {
  if (!userId) return null
  try {
    return window.localStorage.getItem(lastDealerStorageKey(userId))
  } catch {
    return null
  }
}
